import { FormatNumberOptions } from '@monetize/types/common';
import { formatCurrency } from '@monetize/utils/core';
import { FunctionComponent as FC } from 'react';
import MText, { MTextProps } from './MText';

interface MCurrencyProps extends MTextProps {
  amount: number | string | null | undefined;
  options: Omit<FormatNumberOptions, 'currency'> & { currency: string };
}
export const MCurrency: FC<MCurrencyProps> = (props: MCurrencyProps) => {
  const { amount, options, ...rest } = props;
  const formatted = formatCurrency(amount, options);
  return <MText {...rest}>{formatted}</MText>;
};
